import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_DEBTS,
	STR_CHARITY,
	STR_EXPENSES,
	STR_INCOME,
	STR_INSURANCE,
	STR_INVESTMENTS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SAVINGS,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_MORE,
	STR_UTT_CALCULATOR,
	STR_LOAN_CALCULATOR,
	STR_BOND_CALCULATOR,
	STR_LEARN_MORE,
	STR_CALCULATORS,
	STR_UTT_MONTHLY_INVESTMENT_CALC,
	STR_UTT_SINGLE_SUM_INVESTMENT_CALC,
	STR_CONTACT_US,
	STR_FLOAT_LOAN_TERMS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCall, MdEmail, MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import { GiBrain, GiPayMoney } from "react-icons/gi";
import { TbCalculator, TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import { PiStudent } from "react-icons/pi";
import MobileInterface from "../MobileInterface";
import { FaTelegram, FaWhatsapp } from "react-icons/fa";

export default function FLoatLoanTerms(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getSystemParams();
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<div className="row" style={{ marginTop: "10px", marginBottom: "30px", }}>

								<div className="col-md-12">
									<h6
										className="main-section-title"
									>
										{STR_FLOAT_LOAN_TERMS[appContext.language]}
									</h6>
								</div>

								<div
									className="col-12 mt-2 mb-2" 
								>
									<pre>
										{(appContext.language === 'sw') ? appContext.systemParams.loanTcSw : appContext.systemParams.loanTcEn}
									</pre>
								</div>


							</div>
						</div>



					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}